/* CUSTOM coffee-journey (Folke 2026-07-18): ruhige, scroll-getriggerte Geste, laeuft EINMAL beim Reinscrollen
   und ist per Klick auf die Karte wieder abspielbar.
   1) Die gestrichelte Route zeichnet sich in EINE Richtung (Origin -> Roester -> Studio) via Masken-Reveal.
   2) Die km-Zahl zaehlt einmal hoch (0 -> Ziel) und bleibt stehen.
   Bewusst langsam. Kein wandernder Punkt. Respektiert prefers-reduced-motion. */
(function () {
  if (window.__coffeeJourney) return;
  window.__coffeeJourney = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DRAW = 3800;   // ms — Linie zeichnet sich (langsam)
  var COUNT = 3400;  // ms — km-Zahl zaehlt hoch

  function deKm(n) { n = Math.round(n); var s = String(n); return n >= 1000 ? s.slice(0, -3) + '.' + s.slice(-3) : s; }

  function setup(sec) {
    var reveal = sec.querySelector('[data-reveal]');
    var kmEl = sec.querySelector('[data-km-count]');
    var kmTarget = kmEl ? parseInt(kmEl.getAttribute('data-km-target'), 10) || 0 : 0;
    var map = sec.querySelector('.coffee-journey__map');
    var L = (reveal && reveal.getTotalLength) ? reveal.getTotalLength() : 0;
    var kmRaf = null;

    if (reveal && L) { reveal.style.strokeDasharray = L; reveal.style.strokeDashoffset = reduce ? 0 : L; }

    function countUp() {
      if (!kmEl || !kmTarget) return;
      if (reduce) { kmEl.textContent = deKm(kmTarget); return; }
      if (kmRaf) cancelAnimationFrame(kmRaf);
      var t0 = null;
      var tick = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / COUNT, 1);
        var eased = 1 - Math.pow(1 - p, 3);            // easeOutCubic
        kmEl.textContent = deKm(eased * kmTarget);
        if (p < 1) kmRaf = requestAnimationFrame(tick);
        else kmEl.textContent = deKm(kmTarget);
      };
      kmRaf = requestAnimationFrame(tick);
    }

    function play() {
      sec.classList.add('is-drawn');
      if (reveal && L && !reduce) {
        reveal.style.transition = 'none';
        reveal.style.strokeDashoffset = L;             // zuruecksetzen (versteckt)
        void reveal.getBoundingClientRect();           // Reflow erzwingen
        reveal.style.transition = 'stroke-dashoffset ' + (DRAW / 1000) + 's cubic-bezier(.22,.61,.36,1)';
        reveal.style.strokeDashoffset = '0';           // zeichnen
      }
      countUp();
    }

    if (reduce || !('IntersectionObserver' in window)) {
      play();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { play(); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(sec);
    }

    // Klick auf die Karte -> Animation nochmal abspielen.
    if (map && !reduce) {
      map.style.cursor = 'pointer';
      map.setAttribute('title', 'Nochmal abspielen');
      map.addEventListener('click', function () { play(); });
    }

    // Easter Egg (nur aktiv wenn Markup vorhanden) — Studio-Knoten antippen.
    var studio = sec.querySelector('[data-studio-node]');
    var egg = sec.querySelector('[data-egg]');
    if (studio && egg) {
      var toggle = function () { egg.hidden = !egg.hidden; sec.classList.toggle('egg-open', !egg.hidden); };
      studio.addEventListener('click', toggle);
      studio.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    }
  }

  function init() {
    var secs = document.querySelectorAll('.coffee-journey');
    for (var i = 0; i < secs.length; i++) setup(secs[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
